import React from "react";
import { PericlesProvider } from "@pericles/framework-frontend";

import { useAuth } from "../hooks/auth";

const DEFAULT_BASE_URL = "/api";

export function AuthenticatedPericlesProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const { activeTenantId, loading } = useAuth();

  const tenantAwareFetcher = React.useCallback(async (input: RequestInfo, init?: RequestInit) => {
    const response = await fetch(input, init);
    if (response.status === 409) {
      const payload = await response.clone().json().catch(() => null);
      const code = (payload as { code?: string } | null)?.code;
      if (code === "TENANT_NOT_SELECTED" || code === "TENANT_ACCESS_REVOKED") {
        window.dispatchEvent(new CustomEvent("pericles-tenant-required"));
      }
    }
    return response;
  }, [activeTenantId, loading]);

  return (
    <PericlesProvider baseUrl={DEFAULT_BASE_URL} fetcher={tenantAwareFetcher}>
      {children}
    </PericlesProvider>
  );
}
